// extracted by mini-css-extract-plugin
export default {"inputBlock":"StripeInput_inputBlock__v5biw","input":"StripeInput_input__JvUw6","placeholder":"StripeInput_placeholder__hFpkt"};